import React from 'react';
import PropTypes from 'prop-types';
import { Button, Grid } from '@material-ui/core';
//import { voucherStyles } from '../../functions/styles';
//import AddIcon from '@material-ui/icons/Add';
//import SendIcon from '@material-ui/icons/Send';
//import CancelIcon from '@material-ui/icons/Cancel';
//import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { isMobile } from 'react-device-detect';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({

    submit: {
        [theme.breakpoints.up('xs')]: {
            fontSize: '60%',
            color: '#1a1919',
            borderRadius: '0px',
            borderLeft: '3px solid rgba(255, 198, 0)',
            backgroundColor: "white",
            fontFamily: 'Ubuntu',
            "&:hover": {
                backgroundColor: "white"
            }
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: '100%',
            color: '#1a1919',
            borderLeft: '3px solid rgba(255, 198, 0)',
            backgroundColor: "white",
            fontFamily: 'Ubuntu',
            "&:hover": {
                backgroundColor: "white"
            }
        },
        [theme.breakpoints.up('md')]: {
            fontSize: '100%',
            color: '#1a1919',
            borderLeft: '3px solid rgba(255, 198, 0)',
            backgroundColor: "white",
            fontFamily: 'Ubuntu',
            "&:hover": {
                backgroundColor: "white"
            }
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: '100%',
            color: '#1a1919',
            borderLeft: '3px solid rgba(255, 198, 0)',
            backgroundColor: "white",
            fontFamily: 'Ubuntu',
            "&:hover": {
                backgroundColor: "white"
            }
        },
        [theme.breakpoints.up('xl')]: {
            fontSize: '100%',
            color: '#1a1919',
            borderLeft: '3px solid rgba(255, 198, 0)',
            backgroundColor: "white",
            fontFamily: 'Ubuntu',
            "&:hover": {
                backgroundColor: "white"
            }
        },
    }
}));

const ActivityButtons = props => {
    const { handleDownloadDevice, handleDownloadVoucher, onActionAfter, actionLabels } = props
    const classes = useStyles()
    return (
        <Grid container spacing={3} className = {classes.fondo} alignItems="center" direction="row" justify="center">
            <Grid item xs={12} md={12} ></Grid>
            {/* <Grid item xs={12} md={12}>
                <img src={process.env.PUBLIC_URL + '/images/footer_voucher.png'} alt="Logo" className= {classes.logofooter } />
            </Grid> */}
            <br />
            <Grid item xs={6} md={6} sm = {6}>
                <Button
                    fullWidth
                    onClick={ onActionAfter }
                    variant="contained"
                    color="primary"
                    size="small"
                    className={classes.submit}
                > { actionLabels[0] }</Button>
            </Grid>
            {/* <Grid item xs={6} md={6} sm = {6}>
                <Button
                    fullWidth
                    onClick={ handleSendEmailWithVoucher }
                    variant="contained"
                    color="primary"
                    size="small"
                    startIcon = { <SendIcon />}
                    className={classes.submit}
                >{ actionLabels[1] } </Button>
            </Grid>
            <Grid item xs={6} md={6} sm = {6}>
                <Button
                    fullWidth
                    onClick={ handleCancelTransferForm }
                    variant="contained"
                    color="primary"
                    size="small"
                    startIcon = { <CancelIcon />}
                    className={classes.submit}
                > { actionLabels[2] }</Button>
            </Grid> */}
            { (!isMobile) &&
            
                <Grid item xs={6} md={6} sm = {6}>
                    <Button
                        size="small"
                        fullWidth
                        onClick={ handleDownloadVoucher }
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                    > { actionLabels[3] }</Button>
                </Grid> 
            }
            {
            (isMobile) &&
            
                <Grid item xs={6} md={6} sm = {6}>
                    <Button
                        size="small"
                        fullWidth
                        onClick={ handleDownloadDevice }
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                    > { actionLabels[4] }</Button>
                </Grid> 
            }
        </Grid>
    );
};

ActivityButtons.propTypes = {
    handleDownloadDevice: PropTypes.func.isRequired,
};

export default ActivityButtons;